import React from 'react';
import PropTypes from 'prop-types';

import BrowseTilePair from './BrowseTilePair';

const BrowseDepartmentPair = ({ s3BasePath, department, leftUrl, rightUrl }) => (
  <BrowseTilePair
    title={department}
    leftImage={`${s3BasePath}not_found/${department}_newin`}
    leftImageTitle="NEW IN"
    leftUrl={leftUrl}
    rightImage={`${s3BasePath}not_found/${department}_sale`}
    rightImageTitle="SALE"
    rightUrl={rightUrl}
  />
);

BrowseDepartmentPair.propTypes = {
  department: PropTypes.string.isRequired,
  leftUrl: PropTypes.string.isRequired,
  rightUrl: PropTypes.string.isRequired,
  s3BasePath: PropTypes.string.isRequired,
};

export default BrowseDepartmentPair;
